"use strict";

var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey2(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.Cookie = void 0;
var _tsRes = require("ts-res"),
  _kameleoonData = require("../../kameleoonData"),
  _kameleoonError = require("../../kameleoonError"),
  _types = require("../types"),
  _utilities = require("../../utilities"),
  _logging = require("../../logging");
function _defineProperty(a, b, c) {
  return (b = _toPropertyKey(b)) in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}
function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");
  return "symbol" == _typeof(b) ? b : b + "";
}
function _toPrimitive(a, b) {
  if ("object" != _typeof(a) || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (void 0 !== c) {
    var d = c.call(a, b || "default");
    if ("object" != _typeof(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === b ? String : Number)(a);
}
var Cookie = /*#__PURE__*/function () {
  function Cookie(a) {
    _classCallCheck(this, Cookie);
    var b = a.name,
      c = a.value,
      d = a.nameMatchType,
      e = a.valueMatchType;
    _defineProperty(this, "cookie", void 0), _defineProperty(this, "keyMatchType", void 0), _defineProperty(this, "valueMatchType", void 0), this.cookie = {
      key: null !== b && void 0 !== b ? b : void 0,
      value: null !== c && void 0 !== c ? c : void 0
    }, this.keyMatchType = d, this.valueMatchType = e;
  }
  return _createClass(Cookie, [{
    key: "evaluate",
    value: function evaluate(a) {
      var _this = this;
      var b;
      var c = a.targetingData;
      var d = !this.cookie.key && !this.cookie.value,
        e = !!this.valueMatchType && !!this.keyMatchType;
      if (d || !e) return (0, _tsRes.Ok)(!1);
      var f = this.extractCookie(),
        g = (null === c || void 0 === c || null === (b = c[_kameleoonData.KameleoonData.Cookie]) || void 0 === b ? void 0 : b.cookie) || [];
      return (0, _tsRes.Ok)(f.some(function (a) {
        return _this.checkCondition(a);
      }) || g.some(function (a) {
        return _this.checkCondition(a);
      }));
    }
  }, {
    key: "extractCookie",
    value: function extractCookie() {
      return "undefined" != typeof document && document.cookie ? _kameleoonData.Cookie.fromString(document.cookie).data.cookie : [];
    }
  }, {
    key: "checkCondition",
    value: function checkCondition(a) {
      var b = this.keyMatchType,
        c = a.key,
        d = a.value;
      if (b === _types.NameMatchType.OPTIONAL) {
        var _a = this.cookie;
        return !!this.isOptionalCookie(_a) && this.compareCookieValue(d, _a.value);
      }
      var _this$cookie = this.cookie,
        e = _this$cookie.key,
        f = _this$cookie.value;
      var g;
      return b === _types.NameMatchType.EXACT ? g = c === e : b === _types.NameMatchType.CONTAINS ? g = c.includes(e) : b === _types.NameMatchType.REGULAR_EXPRESSION ? g = _utilities.Parser.parseRegExp(e).test(c) : (_logging.KameleoonLogger.error(_templateObject || (_templateObject = _taggedTemplateLiteral(["Unexpected comparing operation for Cookie condition: ", ""])), b), (0, _kameleoonError.exhaustCheck)(b)), g && this.compareCookieValue(d, f);
    }
  }, {
    key: "compareCookieValue",
    value: function compareCookieValue(a, b) {
      var c = this.valueMatchType;
      return c === _types.ValueMatchType.EXACT ? a === b : c === _types.ValueMatchType.CONTAINS ? a.includes(b) : c === _types.ValueMatchType.REGULAR_EXPRESSION ? _utilities.Parser.parseRegExp(b).test(a) : (_logging.KameleoonLogger.error(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["Unexpected comparing operation for Cookie condition: ", ""])), c), !1);
    }
  }, {
    key: "isOptionalCookie",
    value: function isOptionalCookie(a) {
      var b = a.value;
      return "undefined" != typeof b;
    }
  }]);
}();
exports.Cookie = Cookie;